import { Accordion } from '@trussworks/react-uswds';
import NWS_SEATTLE from './DistrictContent/NWD/NWD.NWS_Seattle';

const USACEDistrictAccordion = [
  {
    id: '1',
    headingLevel: 'h3',
    title: 'Seattle District (NWS)',
    content: <NWS_SEATTLE />,
  },
];

const NWD = () => (
  <>
    <section id='nwd'>
      <h6 className='margin-bottom-1'>Regulatory Districts with JPA's</h6>
      <Accordion bordered items={USACEDistrictAccordion} multiselectable={true} />
    </section>
  </>
);

export default NWD;
